import { useEffect, useState } from 'react'
//import { base64ToBlob } from "../../Utils/Functions/Files";
import { getPDFCot } from "../../Fetch/GetPDF";
import { useParams } from "react-router";
import Loading from "../Loading/Loading";
import './pdfcot.css'


export default function PdfC() {

    let params = useParams();
    const [pdfData, setPdfData] = useState({ valid: false, data: [], Loading: false });

    useEffect(() => {

        getPDFCot(params.hash, params.id).then(resf => {
            if (resf.valid) {
                if (resf.payload.length > 0) {
                    document.getElementById('Tit').innerText = 'KMP-' + params.id;
                    setPdfData(v => (
                        {
                            ...v,
                            Loading: true,
                            valid: resf.valid,
                            data: resf.payload.map((d, i) => {
                                // const blobi = base64ToBlob(d.pdf, 'application/pdf');
                                // const url = URL.createObjectURL(blobi)

                                return (
                                    {
                                        ...d.pdf,
                                        pdf: "data:application/pdf;base64," + d.pdf
                                        //pdf: url
                                    }
                                )
                            })
                        }))

                }
            } else {
                setPdfData(v => (
                    {
                        ...v,
                        Loading: true,
                        valid: resf.valid,
                        data: resf.payload.map((d, i) => (
                            {
                                ...d.pdf,
                                // pdf: 'data:base64,' + d.pdf
                                pdf: 'data:base64,' + d.pdf
                            }
                        ))
                    }))
            }
        })

    }, [setPdfData, params])

    return (
        pdfData.Loading ?
            pdfData.data.length > 0 ?
                pdfData.data.map((dpdf, ipdf) => (
                    <div className='PDFCot' key={ipdf} >
                        <embed type='application/pdf' src={dpdf.pdf} />
                    </div>
                )) :
                <span>PDF no encontrado</span>
            :
            <Loading />
    )
}